import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/contexts/ToastContext';
import { Mail, Lock, LogIn } from 'lucide-react';
import './Auth.css';
import logo from '@/assets/images/logo.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { signIn } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    if (!email || !password) {
      toast.warning('Preencha todos os campos');
      return;
    }

    setLoading(true);
    const { error } = await signIn(email, password);
    setLoading(false);

    if (error) {
      toast.error(error.message || 'Erro ao fazer login');
    } else {
      toast.success('Login realizado com sucesso!');
      navigate('/');
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src={logo} alt="GHPOnotes" className="auth-logo" />
        <h1 className="auth-title">Bem-vindo de volta</h1>
        <p className="auth-subtitle">Entre para acessar suas notas criptografadas</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <Mail className="input-icon" size={20} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div className="input-group">
            <Lock className="input-icon" size={20} />
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="auth-input"
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            <LogIn size={20} />
            <span>{loading ? 'Entrando...' : 'Entrar'}</span>
          </button>
        </form>

        <p className="auth-footer">
          Não tem uma conta? <Link to="/register" className="auth-link">Criar conta</Link>
        </p>
      </div>
    </div>
  );
}
